import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function AllAddons(props) {
  var history = useHistory();
  const sort = 5;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [items, setItems] = useState([]);
  const [spinner, setSpinner] = useState(true);
  function getData() {
    axios
      .get(
        `${Baseurl.baseurl4}/go-food-super-admin/get-all-verified-addon-details`
      )
      .then((res) => {
        console.log('addons result',res.data.addonDetails)
        setSpinner(false);
        if (res.data.status) {
          setItems(res.data.addonDetails);
          setData(document.querySelectorAll("#job_data tbody tr"))
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  return (
    <Col lg={12}>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div></div>
          {/* {items && items.length === 0 && (
            <button onClick={() => {}} className="btn btn-primary">
              Add Restaurant
            </button>
          )} */}
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>NAME</strong>
                    </th>
                  
                   
                    <th>
                      <strong>Description</strong>
                    </th>
                    <th>
                      <strong>Selection</strong>
                    </th>
                    <th>
                      <strong>Addon Item</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items &&
                    items.map((item, key) => (
                      <tr key={item._id}>
                        <td>{item.RAddonCategoryName}</td>
                        
                        <td>{item.RAddonCategoryDescription}</td>
                        <td>{item.RAddonCategorySelection}</td>
                     <td className="row">
                        {item.RAddonItem&&item.RAddonItem.map((val)=>{
                            return(
                               <>
                                <div className="col-sm-4">
                                {val.ItemName}
                                </div>
                                <div className="col-sm-4">
                                {val.ItemCategory}
                                </div>
                                <div className="col-sm-4">
                                {val.ItemPrice} ₹
                                </div>
                               </>
                            )
                        })}
                      
                       
                     </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                history.push(`View-Addons/${item._id}`)
                                }}
                              >
                                View
                              </Dropdown.Item>
                             
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!items && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero items
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default AllAddons;
